module.exports = __webpack_public_path__ + "static/media/icon-failure.2358c7d5.svg";